import { createComponent as t } from "@lit/react";
const r = ({
  defineCustomElement: e,
  ...o
}) => (typeof e < "u" && e(), t(o));
export {
  r as c
};
//# sourceMappingURL=create-component-C2u0Q7Hs.js.map
